/**
 * TanStack Query hooks for `plan-pause`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	planPauseQueryKeys,
	type CreatePlanPauseBody,
	type ListPlanPauseResponse,
	type PlanPauseRow,
} from "./api";

export function usePlanPauseList(): UseQueryResult<ListPlanPauseResponse, Error> {
	return useQuery({
		queryKey: planPauseQueryKeys.list(),
		queryFn: list,
	});
}

export function usePlanPauseCreate(): UseMutationResult<PlanPauseRow, Error, CreatePlanPauseBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: planPauseQueryKeys.all });
		},
	});
}

export function usePlanPauseDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: planPauseQueryKeys.all });
		},
	});
}
